<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <PrintTrainingAnalysis />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrintTrainingAnalysis from "../../commonPages/PrintTrainingAnalysis";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
     PrintTrainingAnalysis
  },
  data: () => ({
    isSidebar: false
  })
};
</script>

<style scoped></style>
